enum LastMessagedDate {
  FifteenOrLess = 'FIFTEEN_DAYS_OR_LESS',
  FifteenToThirty = 'FIFTEEN_TO_THIRTY_DAYS',
  ThirtyToFortyFive = 'THIRTY_TO_FORTY_FIVE_DAYS',
  MoreThanFortyFive = 'MORE_THAN_FORTY_FIVE_DAYS',
}

export default LastMessagedDate;
